var _style, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 370 370",
    style: {
      enableBackground: "new 0 0 370 370"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#63B9E9;}\n\t.st3{fill:#009E3A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.7,5C37.6,5,5,37.6,5,77.7v214.6C5,332.4,37.6,365,77.7,365h214.6c40.1,0,72.7-32.6,72.7-72.7V77.7 C365,37.6,332.4,5,292.3,5H77.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.9,333.7c-98.8,0-153-51.1-153-150.3c0-100.7,53.2-147.3,153-147.3s140,46.6,140,147.3 C331.9,282.6,290.7,333.7,191.9,333.7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M365,280.6c0,46.4-38,84.4-84.4,84.4H89.4C43,365,5,327,5,280.6V89.4C5,43,43,5,89.4,5h191.2 C327,5,365,43,365,89.4V280.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.7,335.3c-101.3,0-157-51.6-157-151.8c0-101.7,54.6-148.8,157-148.8s143.6,47.1,143.6,148.8 C335.3,283.7,293,335.3,191.7,335.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.7,162.6c0-8.5,4.6-14.1,19.7-14.1c11.8,0,19.7,2.3,23.3,16.1h66.9V94.7h-50.8v54.1h-13.1 c-4.9-45.9-22.6-57.1-58.7-57.1C113.5,91.8,98,117,98,142.6c0,27.5,11.1,50.8,49.8,50.8c14.4,0,27.9-0.7,40.7-0.7 c15.4,0,18.7,4.9,18.7,14.4c0,9.8-5.6,13.8-16.7,13.8c-14.8,0-23-3.9-26.2-13.8H97.4v66.2h50.2v-50.8h13.1 c3.6,44.9,22.6,54.1,64.3,54.1c39.7,0,53.5-23,53.5-48.9c0-31.2-8.2-52.8-53.1-52.8c-12.5,0-36.7,1-40.3,1 C168.2,176.1,162.7,171.5,162.7,162.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.b3956b82d4b60819cb8dd335ff509d6e.svg";
export { ForwardRef as ReactComponent };